import { ChevronDown, Sparkles, TrendingUp } from "lucide-react";
import React, { useState } from "react";
import CircularProgress from "../../CircularProgress";
import useThemeColors from "../../../../hooks/useThemeColors";

const HealthProgressOverview: React.FC = () => {
  const [showProgressDetails, setShowProgressDetails] = useState(false);

  const colors = useThemeColors();

  return (
    <div className="mx-4 border border-secondary rounded-lg p-4 bg-[var(--bg-primary)]">
      <div className="flex flex-row items-center justify-between">
        <div className="flex flex-row items-center gap-2">
          <div className="bg-[var(--icon-bg-primary)] rounded-md p-2">
            <Sparkles className="w-4 h-4 text-[var(--app-primary)]" />
          </div>
          <p className="font-medium text-primary text-base">
            Health Progress Overview
          </p>
        </div>
        <TrendingUp className="w-5 h-5 text-green-500" />
      </div>
      <div className="flex flex-row items-center justify-between">
        <div className="flex flex-col items-center justify-center">
          <CircularProgress
            color={colors?.primary}
            width={100}
            height={100}
            value={70}
          >
            48%
          </CircularProgress>
          <div className="text-sm text-gray-600">Liver Function</div>
        </div>

        <div className="flex flex-col items-center justify-center">
          <CircularProgress
            color={colors?.primary}
            width={100}
            height={100}
            value={70}
          >
            48%
          </CircularProgress>
          <div className="text-sm text-gray-600">Sumptom Relief</div>
        </div>

        <div className="flex flex-col items-center justify-center">
          <CircularProgress
            color={colors?.primary}
            width={100}
            height={100}
            value={70}
          >
            48%
          </CircularProgress>
          <div className="text-sm text-gray-600">Adherence Rate</div>
        </div>
      </div>

      <div className="mt-4 p-4 bg-purple-50 rounded-lg">
        <div
          className="flex flex-row items-center justify-between "
          onClick={() => setShowProgressDetails(!showProgressDetails)}
        >
          <div className="text-sm text-primary">
            {showProgressDetails ? "Hide Details" : "Show Progress Details"}
          </div>
          <div>
            <ChevronDown
              className={`w-5 h-5 text-primary transition-transform duration-300 ${
                showProgressDetails ? "rotate-180" : ""
              }`}
            />
          </div>
        </div>

        {showProgressDetails && (
          <div className="mt-4">
            <div className="text-sm text-primary">
              <b>Excellent progress!</b> Your liver function has improved
              significantly with 70% reduction in symptoms. Continue current
              treatment plan for optimal recovery.
            </div>
          </div>
        )}
      </div>

      <div className="flex items-center justify-center gap-2 mt-4">
        <div className="bg-secondary p-2 rounded-full"></div>
        <div className="text-sm text-secondary">For reference only</div>
      </div>
    </div>
  );
};

export default HealthProgressOverview;
